<template>
  <div>
    <div :class="isLoggedIn ? 'app' : ''">
      <div v-if="isLoggedIn">
        <Header></Header>
      </div>
      <div v-else>
        <login />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./components/Header";
import login from "./components/Login1";
import { GET_USER_COURTS } from "./store/actions.type";

export default {
  name: "App",
  components: {
    Header,
    login
  },
  data() {
    return {
      ready: false
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isAuthenticated;
    }
  },
  async mounted() {
    if (this.isLoggedIn) {
      await this.$store.dispatch(GET_USER_COURTS);
    }
  }
};
</script>

<style lang="scss" scoped>
.appLogin {
  width: 1920px;
  height: 1080px;
  height: 950px;
  background-color: red;
}

.body {
  margin: 0 139px 239px 368px;
  color: blue;
  color: #ffffff;
}
</style>
